type LockedFeature = 'builder' | 'billing' | 'settings';

type LockedFeatureConfig = {
  badge: string;
  title: string;
  description: string;
  highlights: string[];
};

const env =
  typeof import.meta !== 'undefined'
    ? (import.meta.env as Record<string, string | undefined>)
    : undefined;

function readLockedFlag(key: string, fallback = true): boolean {
  const value = env?.[key];
  if (value === 'false') return false;
  if (value === 'true') return true;
  return fallback;
}

export const RELEASE_LOCKS: Record<LockedFeature, boolean> = {
  builder: readLockedFlag('VITE_LOCK_BUILDER', true),
  billing: readLockedFlag('VITE_LOCK_BILLING', true),
  settings: readLockedFlag('VITE_LOCK_SETTINGS', true),
};

export const LOCKED_FEATURE_CONTENT: Record<LockedFeature, LockedFeatureConfig> = {
  builder: {
    badge: 'Builder Locked',
    title: 'Website Builder is coming soon',
    description:
      'The builder is still being hardened for release. We are keeping site creation and export locked until the remaining edge cases are cleaned up.',
    highlights: ['Visual editing', 'Site export and deploy', 'Template and project publishing'],
  },
  billing: {
    badge: 'Billing Locked',
    title: 'Billing is coming soon',
    description:
      'Credits and checkout are being held back until the live payment paths are fully verified. We are not exposing payment flows until that work is complete.',
    highlights: ['Credit packages', 'Stripe checkout', 'Solana payment verification'],
  },
  settings: {
    badge: 'Settings Locked',
    title: 'Settings are coming soon',
    description:
      'Project settings stay locked for now while the live API key and configuration flows are finalized for release.',
    highlights: ['API key management', 'Project configuration', 'Production access controls'],
  },
};

export type { LockedFeature, LockedFeatureConfig };
